
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100","preserveAspectRatio":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.63 1L99 70.46v27.13L2.41 1h14.22M17 0H0l100 100V70L17 0z"}})])
          )
        }
      }
    